import React from 'react';
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip as ChartTooltip, XAxis, YAxis } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import { gatePerformance, modelPerformance } from '../../data/analytics';
export function GateForecastChart() {
  return <SectionCard title="Gate clearance — forecast vs actual" description="Gates the model predicted would clear each month, against those that actually cleared, with officer overrides" actions={<span className="rounded-sm border border-uae-navy/30 bg-uae-navy/10 px-1.5 py-0.5 font-mono text-[11px] text-uae-navy" data-id="element-418" data-mp="1zxgi9lbrdsa7">
          {modelPerformance.gateForecastAccuracy}% accuracy
        </span>} data-id="element-417" data-mp="1q1wvppj345y4">
      <div className="h-64 w-full" data-id="element-419" data-mp="28xn35s9sduje">
        <ResponsiveContainer width="100%" height="100%" data-id="element-420" data-mp="al4w0kj2xr0b">
          <ComposedChart data={gatePerformance} margin={{
          top: 4,
          right: 8,
          left: -20,
          bottom: 0
        }} data-id="element-421" data-mp="amfwobh8ain7">
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} data-id="element-422" data-mp="enrrqwivfw2s" />
            <XAxis dataKey="month" tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={{
            stroke: 'var(--border)'
          }} data-id="element-423" data-mp="29zyapcpg8l5p" />
            <YAxis allowDecimals={false} tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={false} data-id="element-424" data-mp="1v8z4u9g00apt" />
            <ChartTooltip contentStyle={{
            fontSize: 12,
            borderRadius: 4,
            border: '1px solid var(--border)'
          }} data-id="element-425" data-mp="2nxms2akb5a60" />
            <Legend wrapperStyle={{
            fontSize: 11
          }} data-id="element-426" data-mp="2ixid4oz1snhw" />
            <Bar dataKey="overrides" name="Overrides" fill="var(--chart-5)" radius={[2, 2, 0, 0]} data-id="element-427" data-mp="2dzgto2xpmm5w" />
            <Line type="monotone" dataKey="predicted" name="Predicted clearances" stroke="var(--chart-3)" strokeWidth={2} strokeDasharray="4 3" dot={{
            r: 3
          }} data-id="element-428" data-mp="17jd59kvprtha" />
            <Line type="monotone" dataKey="actual" name="Actual clearances" stroke="var(--chart-1)" strokeWidth={2} dot={{
            r: 3
          }} data-id="element-429" data-mp="3qr0dq7ktavlo" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </SectionCard>;
}